import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UiHelperService {

  multiplier = 1;
  constructor() {
    this.setMultiplier();

    window.addEventListener("resize", () => {
      this.setMultiplier();
    })
  }

  /**
   * You give px in screen design, it scales it to the current root font size
   * @param px
   */
  getScaledPixel(px: number): number {
    return px * this.multiplier;
    // let scaledPixel = px;
    // const windowWidth = window.innerWidth;

    // if(windowWidth < 768) {
    //   // font-size: 2.4vw;
    //
    //   scaledPixel = windowWidth / 100 * 2.4 * px / 10;
    //
    // } else if (windowWidth < 1322) {
    //   // font-size: calc(6.6px + (100vw - 992px) * (6.6 / 992));
    //   scaledPixel = px * (6.6 + (windowWidth - 992) * (6.6 / 992)) / 10;
    // } else {
    //   // font-size: calc(6px + (100vw - 992px) * (6 / 992));
    //   scaledPixel = px * (6 + (windowWidth - 992) * (6 / 992)) / 10;
    // }


    // return scaledPixel;

  }

  private setMultiplier(): void {
    const htmlEl = document.querySelector("html");

    if(htmlEl) {
      const rootFontSize = window.getComputedStyle(htmlEl);

      const rootFontSizeFloat = parseFloat(rootFontSize.fontSize);
      this.multiplier = rootFontSizeFloat / 10;
    }
  }
}
